'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _generic = require('./components/generic');

Object.defineProperty(exports, 'Generic', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_generic).default;
  }
});

var _genericForm = require('./components/generic-form');

Object.defineProperty(exports, 'GenericForm', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_genericForm).default;
  }
});

var _toastMessage = require('./components/toast-message');

Object.defineProperty(exports, 'ToastMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toastMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/index.js
// module id = 64
// module chunks = 1